const XSS_WHITE_LIST_LABEL = {
  whiteList: {
    span: ["class"],
  },
};

const XSS_WHITE_LIST_TAG = {
  whiteList: {
    span: ["class"],
  },
};

export default {
  XSS_WHITE_LIST_LABEL: XSS_WHITE_LIST_LABEL,
  XSS_WHITE_LIST_TAG: XSS_WHITE_LIST_TAG,
};
